const MESSAGE_KEYS = [
    "message",
    "error",
    "errorMessage",
    "detail",
    "reason",
    "errors",
    "validationErrors",
    "fieldErrors",
    "results",
    "body",
    "agentBulkResults",
    "messages",
];

const cleanToken = (value) => {
    const raw = String(value ?? "").trim();
    if (!raw) return "";

    const withoutLevel = raw.replace(/^\s*(ERROR|WARN(?:ING)?)\s*:\s*/i, "").trim();
    return withoutLevel;
};

const splitMessage = (value) => {
    const cleaned = cleanToken(value);
    if (!cleaned) return [];

    return cleaned
        .split(/[;\n\r]+/)
        .map((part) => part.trim())
        .filter(Boolean);
};

const collectApiMessages = (value, out = [], depth = 0) => {
    if (depth > 6 || value == null) return out;

    if (typeof value === "string") {
        out.push(...splitMessage(value));
        return out;
    }

    if (Array.isArray(value)) {
        value.forEach((item) => collectApiMessages(item, out, depth + 1));
        return out;
    }

    if (typeof value === "object") {
        MESSAGE_KEYS.forEach((key) => collectApiMessages(value?.[key], out, depth + 1));
    }

    return out;
};

export const getCpErrorMessages = (value, { max = 12 } = {}) => {
    const seen = new Set();
    const out = [];

    collectApiMessages(value)
        .map((msg) => msg.trim())
        .filter(Boolean)
        .forEach((msg) => {
            const dedupeKey = msg.toLowerCase();
            if (seen.has(dedupeKey)) return;
            seen.add(dedupeKey);
            out.push(msg);
        });

    return out.slice(0, Math.max(1, Number(max) || 12));
};

export const hasApiValidationFailure = (resp) => {
    if (!resp || typeof resp !== "object") return false;
    if (Number(resp?.summary?.failed || 0) > 0) return true;

    if (Array.isArray(resp?.results)) {
        const failedResult = resp.results.some((item) => {
            if (item?.ok === false) return true;
            const nested = Array.isArray(item?.body?.agentBulkResults) ? item.body.agentBulkResults : [];
            return nested.some((row) => String(row?.status || "").trim().toUpperCase() === "FAILED");
        });
        if (failedResult) return true;
    }

    const status = String(resp?.status ?? resp?.result ?? "").trim().toLowerCase();
    if (["error", "failed", "failure", "invalid"].includes(status)) return true;

    if (resp?.success === false || resp?.ok === false || resp?.valid === false || resp?.isValid === false) return true;
    if (Array.isArray(resp?.errors) && resp.errors.length > 0) return true;
    if (Array.isArray(resp?.validationErrors) && resp.validationErrors.length > 0) return true;
    if (resp?.fieldErrors && typeof resp.fieldErrors === "object" && Object.keys(resp.fieldErrors).length > 0) return true;

    return false;
};
